import axios from "axios";
import {
  Button as Button2,
  DataGrid,
  DropDownBox,
  Popup,
  SelectBox,
} from "devextreme-react";
import {
  Button,
  Column,
  Editing,
  Export,
  FilterRow,
  Form,
  GroupPanel,
  Grouping,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Paging,
  PatternRule,
  // Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { formatDate } from "devextreme/localization";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/hasPermission";
import { PERM } from "../../utils/permissions";
import { notifyMsg } from "../common/notify";
import SignatureItem from "./SignatureItem";
import SignatureTrainerItem from "./SignatureTrainerItem";
import {
  CAT,
  CAT_FILTER,
  CAT_OBJ,
  PROVIDER,
  TYPE,
  TYPE_EXTERNAL,
  TYPE_OBJ,
} from "./data";

import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import jsPDF from "jspdf";
import { malgun } from "../common/malgun";

import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import TrainingReport from "./TrainingReport";
import TrainingReportItem from "./TrainingReportItem";
import { hBeccoCRO } from "./hBeccoCRO";

export default function TrainingRecord(props) {
  const [dataSource, setDataSource] = useState(null);

  // const employeeNo = useSelector((state) => state.userInfo.employeeNo);
  const userInfo = useSelector((state) => state.userInfo);
  const canSeeMgrTab = hasPermission(userInfo.permissions, PERM.TR_MGR_TAB);

  const { trRecGridRef } = props;

  // TrainingProgramItem
  const trRef = useRef(null);
  const extTrDataGridRef = useRef(null);

  const [trValue, setTrValue] = useState(null);
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const [trDataSource, setTrDataSource] = useState(null);
  const [extTrDataSource, setExtTrDataSource] = useState(null);
  const [extTitleDataSource, setExtTitleDataSource] = useState(null);

  const [employeeDataSource, setEmployeeDataSource] = useState(null);
  const [currentEmployeeNo, setCurrentEmployeeNo] = useState(
    userInfo.employeeNo
  );

  const [reportPopupVisible, setReportPopupVisible] = useState(false);
  const [trRecData, setTrRecData] = useState(null);
  // const [fileListDataSource, setFileListDataSource] = useState(null);
  // const [reportDescr, setReportDescr] = useState(null);
  // const reportDescriptionRef = useRef(null);
  // const reportTabPanelRef = useRef(null);

  useEffect(() => {
    setSetDataSource();

    setTrDataSource(
      new CustomStore({
        loadMode: "raw",
        key: "trId",
        load: async () => {
          try {
            const result = await axios.get(
              // `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr?type=1,2,3,9&provider=1`
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr?type=2,3,9&provider=1`
            );

            return result.data;
          } catch (error) {
            return console.log(error);
          }
        },
      })
    );

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr/external/title`
      )
      .then((result) => {
        setExtTitleDataSource(
          new DataSource({
            store: result.data,
            type: "array",
            key: "title",
            sort: ["title"],
          })
        );
      });

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee?div=${userInfo.div}&jd=${userInfo.jd}`
      )
      .then((result) => {
        setEmployeeDataSource(
          new DataSource({
            store: {
              type: "array",
              data: result.data,
              key: "employeeNo",
            },
            group: "div",
          })
        );
      });
  }, []);

  useEffect(() => {
    if (userInfo.employeeNo == currentEmployeeNo) {
      setSetDataSource();
    } else {
      setDataSource(
        new CustomStore({
          key: "tpId",
          load: async () => {
            try {
              const result = await axios.get(
                `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/${currentEmployeeNo}`
              );

              return result.data;
            } catch (error) {
              return console.log(error);
            }
          },
        })
      );
    }
  }, [currentEmployeeNo]);

  // [2023-05-19]
  // useEffect(() => {
  //   if (reportDescriptionRef.current) {
  //     reportDescriptionRef.current.instance.option("value", reportDescr);
  //   }
  // }, [reportDescr]);

  const setSetDataSource = () => {
    setDataSource(
      new CustomStore({
        key: "tpId",
        load: async () => {
          try {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/my`
            );

            setExtTrDataSource(
              new CustomStore({
                loadMode: "raw",
                key: "trId",
                load: async () => {
                  try {
                    const result = await axios.get(
                      `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr?provider=2&employeeNo=${userInfo.employeeNo}`
                    );

                    return result.data;
                  } catch (error) {
                    return console.log(error);
                  }
                },
                insert: async (values) => {
                  values = {
                    ...values,
                    employeeNo: userInfo.employeeNo,
                    provider: "2",
                  };

                  await axios.post(
                    `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr`,
                    values
                  );
                },

                update: async (key, values) => {
                  const trData = {
                    // employeeNo: userInfo.employeeNo,
                  };
                  const tpData = { employeeNo: userInfo.employeeNo };

                  for (const key in values) {
                    if (
                      key == "cat" ||
                      key == "type" ||
                      key == "title" ||
                      key == "time" ||
                      key == "extProvider"
                    ) {
                      trData[key] = values[key];
                    } else if (
                      key == "date" ||
                      key == "trainer" ||
                      key == "loc"
                    ) {
                      tpData[key] = values[key];
                    }
                  }

                  // Update Training Program
                  const result = await axios.put(
                    `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr/${key}`,
                    trData
                  );

                  const tpId = result.data.tpId;

                  if (Object.keys(tpData).length > 1) {
                    await axios.put(
                      `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${tpId}`,
                      tpData
                    );
                  }
                },

                remove: async (key) => {
                  const result = await axios.delete(
                    `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr/${key}`,
                    {
                      data: {
                        employeeNo: userInfo.employeeNo,
                      },
                    }
                  );

                  if (result.data.msg) {
                    notifyMsg(result.data.msg, "warning");
                  }
                },
              })
            );

            return result.data;
          } catch (error) {
            return console.log(error);
          }
        },
        insert: async (values) => {
          values = {
            ...values,
            // trId: trRef.current.instance.option("value")[0],
            trainee: [userInfo.employeeNo],
            employeeNo: userInfo.employeeNo,
          };

          if (values.provider == 1) {
            values = {
              ...values,
              trId: trRef.current.instance.option("value")[0],
            };

            await axios.post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp`,
              values
            );
          } else if (values.provider == 2) {
            values = {
              ...values,
              trId: trRef.current.instance.option("value")[0],
            };

            await axios.post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec`,
              values
            );
          } else if (values.provider == 9) {
            await axios.post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr`,
              values
            );
          }
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${key}`,
            {
              data: {
                // employeeNo: employeeNo,
                employeeNo: userInfo.employeeNo,
              },
            }
          );
        },
      })
    );
  };

  const cellRenderTime = (data) => {
    const { time } = data.data;

    return <div>{time}h</div>;
  };

  const cellRenderTrainer = (data) => {
    const { trainer, trainerName } = data.data;

    if (trainerName) {
      return (
        <div>
          {trainerName ? `${trainerName} (${trainer})` : ``}
          {/* {trainerName} ({trainer}) */}
        </div>
      );
    } else {
      return <div>{trainer}</div>;
    }
  };

  const cellRenderTraingerSig = (data) => {
    const { trainerSig } = data.data;

    return <SignatureTrainerItem trainerSig={trainerSig} />;
  };

  const cellRenderSig = (data) => {
    const { tpId, sig } = data.data;

    return (
      <SignatureItem
        gridRef={trRecGridRef}
        tpId={tpId}
        sig={sig}
        isTrainer={false}
        // trainer={employeeNo}
        trainer={userInfo.employeeNo}
      />
    );
  };

  const displayExpr = (item) => {
    const { provider, cat, type, title, date, time, extProvider } = item;

    if (provider == 1) {
      return `[${CAT_OBJ[cat]} | ${TYPE_OBJ[type]}] ${title} (${time} Hours)`;
    } else {
      return `[${extProvider}] ${title} (${date} ~ ${time} Hours)`;
    }
  };

  const onValueChanged = (e) => {
    setTrValue(e.value);

    if (trRef.current.instance.option("value") == null) {
      trRef.current.instance.option("validationStatus", "invalid");
    }
  };

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setIsGridBoxOpened(e.value);
    }
  };

  const contentRender = () => {
    return (
      <DataGrid
        keyExpr={"trId"}
        dataSource={trDataSource}
        hoverStateEnabled={true}
        selectedRowKeys={trValue}
        onSelectionChanged={onSelectionChanged}
        height="100%"
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode="single" />
        <Scrolling mode="virtual" showScrollbar="always" />
        <Paging enabled={true} pageSize={10} />

        <Grouping autoExpandAll={false} expandMode={"rowClick"} />
        <GroupPanel visible={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} placeholder={"Search..."} />

        {/* <Column dataField={"id"} caption="id" /> */}
        <Column dataField={"cat"} caption="Category" width={100} groupIndex={1}>
          <Lookup dataSource={CAT} displayExpr="name" valueExpr="id" />
          <HeaderFilter dataSource={CAT_FILTER} />
        </Column>
        <Column dataField={"type"} caption="Type" width={120}>
          <Lookup dataSource={TYPE} displayExpr="name" valueExpr="id" />
        </Column>
        <Column dataField={"title"} cap tion="Title" />
        <Column dataField={"time"} caption="Time (Hours)" width={150} />
      </DataGrid>
    );
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      title: args.text,
    };

    args.customItem = extTitleDataSource
      .store()
      .insert(newItem)
      .then(() => extTitleDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const extContentRender = () => {
    return (
      <DataGrid
        ref={extTrDataGridRef}
        keyExpr={"trId"}
        dataSource={extTrDataSource}
        hoverStateEnabled={true}
        selectedRowKeys={trValue}
        onSelectionChanged={onSelectionChanged}
        height="100%"
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode="single" />
        <Scrolling mode="virtual" showScrollbar="always" />
        <Paging enabled={true} pageSize={10} />

        <Grouping autoExpandAll={false} expandMode={"rowClick"} />
        <GroupPanel visible={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} placeholder={"Search..."} />

        {/* <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"Training.TrainingRecord"}
        /> */}

        <Editing
          // mode={"form"}
          mode="popup"
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Popup
            title={"Training Record"}
            showTitle={true}
            height={"auto"}
            width={1200}
          />
          <Form
            labelMode={"outside"}
            showColonAfterLabel={false}
            labelLocation={"top"}
            minColWidth={300}
            colCount={2}
            // colCountByScreen={{ sm: 2, md: 4 }}
            // screenByWidth={(width) => {
            //   return width < 720 ? "sm" : "md";
            // }}
            validationGroup="externalTrainingProgram"
          >
            <SimpleItem dataField={"cat"} />
            <SimpleItem dataField={"type"} />
            <SimpleItem dataField={"extProvider"} />
            <SimpleItem
              dataField={"title"}
              editorType="dxSelectBox"
              editorOptions={{
                dataSource: extTitleDataSource,
                displayExpr: "title",
                valueExpr: "title",
                searchMode: "contains",
                searchEnabled: true,
                acceptCustomValue: true,
                onCustomItemCreating: onCustomItemCreating,
              }}
            >
              <Label text="Training Title" />
              <RequiredRule message={"* Training Title을 입력해주세요."} />
            </SimpleItem>
            <SimpleItem dataField={"date"} />
            <SimpleItem dataField={"time"} />
            <SimpleItem dataField={"loc"} />
            <SimpleItem dataField={"trainer"} />
          </Form>
        </Editing>

        <Column
          dataField={"cat"}
          caption="Category"
          width={100}
          groupIndex={1}
          editorOptions={{ showClearButton: true }}
        >
          <Lookup dataSource={CAT} displayExpr="name" valueExpr="id" />
          <HeaderFilter dataSource={CAT_FILTER} />
          <RequiredRule message={"* Training Category를 입력해주세요."} />
        </Column>
        <Column
          dataField={"type"}
          caption="Type"
          width={120}
          editorOptions={{ showClearButton: true }}
        >
          <Lookup
            dataSource={TYPE_EXTERNAL}
            displayExpr="name"
            valueExpr="id"
          />
          <RequiredRule message={"* Training Type을 입력해주세요."} />
        </Column>
        <Column
          dataField={"extProvider"}
          caption="Provider"
          width={200}
          editorOptions={{ showClearButton: true }}
        >
          <RequiredRule message={"* Training Provider를 입력해주세요."} />
        </Column>
        {/* <Column
          dataField={"title"}
          caption="Title"
          editorOptions={{ showClearButton: true }}
        >
          <RequiredRule message={"* Training Title를 입력해주세요."} />
        </Column> */}
        <Column
          dataField={"title"}
          caption="Title"
          editorType="dxSelectBox"
          editorOptions={{
            showClearButton: true,
            // dataSource: extTitleDataSource,
            // displayExpr: "title",
            // valueExpr: "id",
            // acceptCustomValue: true,
          }}
        ></Column>
        <Column
          dataField="date"
          catpion="Date"
          dataType="datetime"
          format={"yyyy-MM-ddTHH:mm:ss"}
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
            showClearButton: true,
          }}
          width={170}
        >
          <RequiredRule message={"* Training Date를 입력해주세요."} />
        </Column>
        <Column
          dataField={"time"}
          caption="Time (Hours)"
          width={150}
          cellRender={cellRenderTime}
          dataType="number"
          editorOptions={{ showClearButton: true }}
        >
          <RequiredRule message={"* Training Time을 입력해주세요."} />
          <PatternRule
            message="* Time은 최대 99시간까지 가능합니다. (소수점 2자리)"
            pattern={/^[0-9]{0,2}(\.[0-9]{0,2})?$/}
          />
        </Column>
        <Column
          dataField={"loc"}
          caption="Location"
          width={150}
          editorOptions={{ showClearButton: true }}
        >
          <RequiredRule message={"* Training Location을 입력해주세요."} />
        </Column>
        <Column
          dataField={"trainer"}
          caption="Trainer"
          width={160}
          editorOptions={{ showClearButton: true }}
        >
          <RequiredRule message={"* Trainer를 입력해주세요."} />
        </Column>
      </DataGrid>
    );
  };

  const onSelectionChanged = (e) => {
    // setTrValue(e.selectedRowKeys);

    setTrValue(e.selectedRowKeys);
    setIsGridBoxOpened(false);
  };

  const customizeItem = (item) => {
    if (item) {
      if (
        item.dataField == "trId" //||
        // item.dataField == "loc" ||
        // item.dataField == "date"
      ) {
        // let gridInstance = trRecGridRef.current.instance;
        // let editRowKey = gridInstance.option("editing.editRowKey");
        // let index = gridInstance.getRowIndexByKey(editRowKey);
        // index = index === -1 ? 0 : index;

        // if (gridInstance.cellValue(index, "provider") == "1") {
        //   item.visible = true;
        // }

        if (getProviderValue() == "1") {
          item.visible = true;
        }
      } else if (item.dataField == "extTrId") {
        // let gridInstance = trRecGridRef.current.instance;
        // let editRowKey = gridInstance.option("editing.editRowKey");
        // let index = gridInstance.getRowIndexByKey(editRowKey);
        // index = index === -1 ? 0 : index;

        // if (gridInstance.cellValue(index, "provider") == "2") {
        //   item.visible = true;
        // }
        if (getProviderValue() == "2") {
          item.visible = true;
        }
      } else if (item.dataField == "loc" || item.dataField == "date") {
        // let gridInstance = trRecGridRef.current.instance;
        // let editRowKey = gridInstance.option("editing.editRowKey");
        // let index = gridInstance.getRowIndexByKey(editRowKey);
        // index = index === -1 ? 0 : index;

        // const providerValue = gridInstance.cellValue(index, "provider");
        const providerValue = getProviderValue();

        if (providerValue == "1" || providerValue == "9") {
          item.visible = true;
        }
      } else if (
        item.dataField == "cat" ||
        item.dataField == "type" ||
        item.dataField == "extProvider" ||
        item.dataField == "title" ||
        item.dataField == "time" ||
        item.dataField == "trainer"
      ) {
        if (getProviderValue() == "9") {
          item.visible = true;
        }
      }
    }
  };

  const getProviderValue = () => {
    let gridInstance = trRecGridRef.current.instance;
    let editRowKey = gridInstance.option("editing.editRowKey");
    let index = gridInstance.getRowIndexByKey(editRowKey);
    index = index === -1 ? 0 : index;

    return gridInstance.cellValue(index, "provider");
  };

  const setCellValue = (newData, value) => {
    newData.provider = value;

    setTrValue(null);
  };

  const onSaving = React.useCallback(async (e) => {
    if (trRef.current) {
      if (trRef.current.instance.option("value") == null) {
        trRef.current.instance.option("validationStatus", "invalid");

        e.cancel = true;
      }

      // Training Program Update
      if (e.changes.length == 0) {
        const tpId = trRecGridRef.current.instance.option("editing.editRowKey");

        await axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${tpId}`,
          {
            // tpId: tpId,
            trId: trRef.current.instance.option("value")[0],
            employeeNo: userInfo.employeeNo,
          }
        );

        trRecGridRef.current.instance.refresh();
      }
    }
  }, []);

  const onSaved = React.useCallback((e) => {
    setTrValue(null);
  }, []);

  const onEditingStart = (e) => {
    // e.data.trId = Array.of(e.data.trId);
    setTrValue(Array.of(e.data.trId));

    // setTrValue(e.data.trId);
  };

  const editNDeleteDisabled = (e) => {
    const { provider, type, trainer, trackerComp } = e.row.data;

    // if (provider == 1 && type == 1) {
    if (userInfo.employeeNo != currentEmployeeNo) {
      return true;
    }

    if (trackerComp == "Y") {
      return true;
    }

    if (provider == 1) {
      if (trainer) {
        return true;
      }

      return false;
    } else {
      return false;
    }
  };

  const customizeTextTime = (data) => {
    return `Sum: ${data.value}h`;
  };

  const customizeTextDate = (data) => {
    return `First: ${formatDate(data.value, "yyyy-MM-dd")}`;
  };

  const onClickRefresh = () => {
    trRecGridRef.current.instance.getDataSource().reload();
  };

  const addFooters = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();

    // doc.setFont("helvetica", "italic");
    for (var i = 1; i <= pageCount; i++) {
      doc.setFontSize(10);
      doc.setPage(i);
      doc.text(
        "Page " + String(i) + " of " + String(pageCount),
        doc.internal.pageSize.width / 2,
        // 287,
        doc.internal.pageSize.height - 5,
        {
          align: "center",
        }
      );
    }
  };

  const exportpdf = React.useCallback(() => {
    const doc = new jsPDF({
      orientation: "l",
      unit: "mm",
      format: [297, 210],
      encryption: {
        userPermissions: ["print"],
      },
      compressPdf: true,
    });

    doc.addFileToVFS("malgun.ttf", malgun);
    doc.addFont("malgun.ttf", "malgun", "normal");
    doc.setFont("malgun");

    doc.setFontSize(5);

    const dataGrid = trRecGridRef.current.instance;

    const lastPoint = { x: 0, y: 0 };

    exportDataGridToPDF({
      margin: {
        right: 5,
        left: 5,
        top: 10,
        bottom: 10,
      },
      jsPDFDocument: doc,
      component: dataGrid,

      loadPanel: {
        enabled: true,
        // shading: true,
        // shadingColor: "#f5f5f5",
      },
      // indent: 5,

      topLeft: { x: 1, y: 15 },
      columnWidths: [10, 25, 20, 100, 20, 30, 30, 25, 25],

      customDrawCell({ rect }) {
        if (lastPoint.x < rect.x + rect.w) {
          lastPoint.x = rect.x + rect.w;
        }
        if (lastPoint.y < rect.y + rect.h) {
          lastPoint.y = rect.y + rect.h;
        }
      },

      // autoTableOptions: {
      //   styles: {
      //     font: "malgun",
      //     overflow: "linebreak",
      //     cellWidth: "wrap",
      //     fontSize: 7,
      //     valign: "middle",
      //     halign: "center",
      //     overflowColumns: "linebreak",
      //   },
      //   margin: {
      //     left: 7,
      //     right: 7,
      //     top: 30,
      //   },
      //   startY: 30,
      // },
    }).then(async () => {
      // let pageInfo = doc.internal.getCurrentPageInfo();

      doc.setPage(1);

      // Logo
      doc.addImage(`data:image/png;base64,${hBeccoCRO}`, "png", 7, 7, 20, 7);

      // Header
      const header = `Training Record: [${userInfo.div}] ${userInfo.name} (${userInfo.employeeNo})`;
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFontSize(15);
      const headerWidth = doc.getTextDimensions(header).w;
      doc.text(header, (pageWidth - headerWidth) / 2, 20);

      // addFooters(doc);

      // Footer
      const date = new Date();
      const sDate = `${date.getFullYear()}${String(
        date.getMonth() + 1
      ).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`;

      const footer = new Date(
        Date.now() - date.getTimezoneOffset() * 60000
      ).toISOString();

      const pageCount = doc.internal.getNumberOfPages();

      for (let i = 1; i <= pageCount; i++) {
        // Go to page i
        doc.setFontSize(10);
        doc.setPage(i);
        doc.text(
          "Page " + String(i) + " of " + String(pageCount),
          doc.internal.pageSize.width / 2,
          // 287,
          doc.internal.pageSize.height - 5,
          {
            align: "center",
          }
        );
      }

      doc.setFontSize(9);
      doc.setTextColor("#cccccc");
      const footerWidth = doc.getTextDimensions(footer).w;
      doc.text(footer, lastPoint.x - footerWidth, lastPoint.y + 5);

      // File name
      const title = `Training Record_${userInfo.div}_${userInfo.enName}_${sDate}`;

      doc.setProperties({
        title: title,
        author: "BeccoCRO Inc.",
        creator: "BeccoCRO Inc.",
      });

      doc.save(`${title}.pdf`);
    });
  }, []);

  // const headerCellRender = (data) => {
  //   console.debug("[headerCellRender]");
  //   console.debug("data", data);

  //   return <div style={{ textAlign: "center" }}>{data.column.caption}</div>;
  // };

  // const onValueChangedProvider = (e) => {
  //   console.debug("[onValueChanged]");
  //   console.debug("value", e.value);

  // };

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("My Record");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        const date = new Date();
        const sDate = `${date.getFullYear()}${String(
          date.getMonth() + 1
        ).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`;

        const title = `Training Record_${userInfo.div}_${userInfo.enName}_${sDate}`;

        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `${title}.xlsx`
        );
      });
    });

    e.cancel = true;
  };

  const displayEmployeeExpr = (item) => {
    if (item) {
      return `${item.name} (${item.employeeNo})`;
    } else {
      return null;
    }
  };

  const onEmployeeValueChanged = (e) => {
    setCurrentEmployeeNo(e.value.employeeNo);
  };

  const onClick = async (e) => {
    setReportPopupVisible(true);

    setTrRecData(e.row.data);

    //[2023-05-19]
    // const result = await axios.get(
    //   `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/${e.row.data.tpId}/${e.row.data.SEQ}`
    // );

    // reportDescriptionRef.current.instance.option("value", result.data.rpt);

    // [2023-05-19]
    // setReportDescr(result.data.rpt);

    // [2023-05-19]
    // setSetFileListDataSource(e.row.data);
  };

  // [2023-05-19]
  // const setSetFileListDataSource = async (data) => {
  //   const result = await axios.get(
  //     `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/fileList/${data.tpId}/${data.SEQ}`
  //   );

  //   setFileListDataSource(
  //     new ArrayStore({
  //       key: "id",
  //       data: result.data,
  //     })
  //   );
  // };

  const onHiding = () => {
    setReportPopupVisible(false);

    // [2023-05-19]

    // reportDescriptionRef.current.instance.reset();

    // setFileListDataSource(null);

    // let items = reportTabPanelRef.current.instance.option("items");

    // items.splice(1);

    // reportTabPanelRef.current.instance.repaint();
  };

  return (
    <React.Fragment>
      <DataGrid
        id="trRecGrid"
        ref={trRecGridRef}
        dataSource={dataSource}
        keyExpr="tpId"
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        // focusedRowEnabled={true}
        allowColumnResizing={true}
        wordWrapEnabled={true}
        allowColumnReordering={true}
        hoverStateEnabled={true}
        onSaving={onSaving}
        onSaved={onSaved}
        onEditingStart={onEditingStart}
        height={"100%"}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
        onExporting={onExporting}
      >
        <LoadPanel enabled={true} />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <Export enabled={true} />
        {/* <Export enabled={true} formats={["pdf"]} /> */}
        <GroupPanel visible={true} />
        <SearchPanel visible={true} />
        {/*[TODO] <Scrolling mode={"virtual"} /> */}
        <Editing
          mode={"form"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Form
            labelMode={"outside"}
            showColonAfterLabel={false}
            labelLocation={"top"}
            minColWidth={300}
            colCount={2}
            colCountByScreen={{ sm: 2, md: 4 }}
            screenByWidth={(width) => {
              return width < 720 ? "sm" : "md";
            }}
            validationGroup="trainingRecord"
            customizeItem={customizeItem}
          >
            <SimpleItem
              dataField={"provider"}
              editorType="dxSelectBox"
              editorOptions={{
                dataSource: PROVIDER,
                valueExpr: "id",
                showClearButton: true,
                displayExpr: "name",
                // onValueChanged: onValueChangedProvider,
              }}
            >
              <Label text={"Training Provider"} />
              <RequiredRule message={"* Training Provider를 입력해주세요."} />
            </SimpleItem>
            <SimpleItem colSpan={2} dataField="trId" visible={false}>
              <Label text={"Training Program"} />
              <DropDownBox
                // dataField={"trId"}
                ref={trRef}
                name="trId"
                value={trValue}
                opened={isGridBoxOpened}
                valueExpr="trId"
                deferRendering={false}
                displayExpr={displayExpr}
                placeholder="Select a value..."
                showClearButton={true}
                dataSource={trDataSource}
                onValueChanged={onValueChanged}
                onOptionChanged={onOptionChanged}
                contentRender={contentRender}
                validationGroup="trainingAttendanceList"
                // validationStatus="invalid"
              ></DropDownBox>
              <RequiredRule message={"* Training Program을 선택해주세요."} />
            </SimpleItem>
            {/* <SimpleItem
              dataField={"loc"}
              visible={false}
              editorType={"dxTextBox"}
              editorOptions={{ showClearButton: true }}
            >
              <Label text={"Location"} />
              <RequiredRule message={"* Location을 입력해주세요."} />
            </SimpleItem> */}
            <SimpleItem colSpan={3} dataField="extTrId" visible={false}>
              <Label text={"Training Program"} />
              <DropDownBox
                // dataField={"trId"}
                ref={trRef}
                name="trId"
                value={trValue}
                opened={isGridBoxOpened}
                valueExpr="trId"
                deferRendering={false}
                displayExpr={displayExpr}
                placeholder="Select a value..."
                showClearButton={true}
                dataSource={extTrDataSource}
                onValueChanged={onValueChanged}
                onOptionChanged={onOptionChanged}
                contentRender={extContentRender}
                validationGroup="trainingAttendanceList"
                // validationStatus="invalid"
              ></DropDownBox>
              <RequiredRule message={"* Training Program을 입력해주세요."} />
            </SimpleItem>
            <SimpleItem
              dataField={"extProvider"}
              visible={false}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            ></SimpleItem>
            <SimpleItem
              dataField={"cat"}
              visible={false}
              editorType="dxSelectBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              <RequiredRule message={"* Category를 입력해주세요."} />
            </SimpleItem>
            <SimpleItem dataField={"type"} visible={false}>
              <RequiredRule message={"* Type을 입력해주세요."} />
            </SimpleItem>
            <SimpleItem
              dataField={"title"}
              visible={false}
              editorType="dxTextBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              <RequiredRule message={"* Title을 입력해주세요."} />
            </SimpleItem>
            <SimpleItem
              dataField={"date"}
              editorType="dxDateBox"
              editorOptions={{
                // typ: "datetime",
                displayFormat: "yyyy-MM-ddTHH:mm:ss",
                dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
                showClearButton: true,
              }}
              visible={false}
            >
              <Label text="Date" />
              <RequiredRule
                message={"* Training Date & Time을 입력해주세요."}
              />
            </SimpleItem>
            <SimpleItem
              dataField={"time"}
              visible={false}
              editorType="dxNumberBox"
              editorOptions={{
                showClearButton: true,
              }}
            >
              <Label text="Duration (Hours)" />
              <RequiredRule message={"* Duration을 입력해주세요. "} />
            </SimpleItem>
            <SimpleItem
              dataField={"loc"}
              visible={false}
              editorType="dxTextBox"
              editorOptions={{ showClearButton: true }}
            >
              <Label text="Location" />
            </SimpleItem>
            <SimpleItem dataField={"trainer"} visible={false}></SimpleItem>
          </Form>
        </Editing>
        <Column
          dataField={"no"}
          caption="No"
          dataType={"number"}
          width={70}
          allowFiltering={false}
          alignment="center"
        />
        <Column
          dataField="date"
          caption="Date"
          dataType="datetime"
          format={"yyyy-MM-ddTHH:mm:ss"}
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
          }}
          width={170}
          alignment="center"
        />
        <Column
          dataField="cat"
          caption="Category"
          dataType="string"
          width={110}
          alignment="center"
        >
          <Lookup dataSource={CAT} displayExpr="name" valueExpr={"id"} />
        </Column>
        <Column
          dataField="title"
          caption="Training Title"
          dataType="string"
          //   width={400}
        />
        <Column
          dataField={"provider"}
          caption="Provider"
          width={110}
          setCellValue={setCellValue}
          alignment="center"
        >
          <Lookup dataSource={PROVIDER} displayExpr="name" valueExpr={"id"} />
        </Column>
        <Column
          dataField={"extProvider"}
          caption="External Provider"
          width={200}
          // headerCellRender={headerCellRender}
        />
        <Column
          dataField={"type"}
          caption="Training Type"
          width={200}
          alignment="center"
        >
          <Lookup dataSource={TYPE} displayExpr="name" valueExpr={"id"} />
        </Column>
        <Column dataField={"loc"} visible={false} />
        <Column
          dataField={"time"}
          caption="Duration"
          dataType={"number"}
          width={110}
          cellRender={cellRenderTime}
        />
        <Column
          dataField={"trainer"}
          caption="Trained by"
          width={160}
          cellRender={cellRenderTrainer}
          visible={false}
        />
        <Column
          dataField={"trainedBy"}
          caption="Trained by"
          width={160}
          alignment="center"
        />
        {/* <Column
          dataField={"trainerSig"}
          caption="Trainer Sig."
          alignment={"center"}
          cellRender={cellRenderTraingerSig}
          width={140}
        />
        <Column
          dataField={"sig"}
          caption="My Sig."
          alignment={"center"}
          cellRender={cellRenderSig}
          width={120}
        /> */}
        <Column type="buttons" width={100}>
          <Button name={"delete"} disabled={editNDeleteDisabled} />
          <Button
            icon="doc"
            hint={"Report"}
            render={(data) => {
              return (
                <TrainingReportItem
                  // reportPopupVisible={reportPopupVisible}
                  // setReportPopupVisible={setReportPopupVisible}
                  data={data.data}
                />
              );
            }}
            // visible={visible}
            onClick={onClick}
          />
        </Column>
        {/* <Summary>
          <TotalItem
            column={"time"}
            summaryType="sum"
            customizeText={customizeTextTime}
          />
          <TotalItem
            column={"date"}
            summaryType="min"
            customizeText={customizeTextDate}
          />
        </Summary> */}
        <Toolbar>
          <Item location={"before"} name="groupPanel" />
          <Item
            location={"after"}
            name="addRowButton"
            visible={userInfo.employeeNo == currentEmployeeNo ? true : false}
          />
          <Item>
            <Button2 icon={"refresh"} onClick={onClickRefresh} />
          </Item>
          <Item name="exportButton" />
          <Item>
            <Button2 icon="exportpdf" onClick={exportpdf} />
          </Item>
          <Item name={"searchPanel"} />
          {/* {(canSeeMgrTab || userInfo.jd === "RV") && ( */}
          {canSeeMgrTab && (
            <Item location={"after"}>
              <SelectBox
                dataSource={employeeDataSource}
                defaultValue={currentEmployeeNo}
                displayExpr={displayEmployeeExpr}
                onValueChanged={onEmployeeValueChanged}
                width={180}
                grouped={true}
              />
            </Item>
          )}
        </Toolbar>
      </DataGrid>
      {trRecData && (
        <Popup
          id="reportPopup"
          visible={reportPopupVisible}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          title={
            trRecData
              ? "TRAINING REPORT: " + trRecData.title
              : "TRAINING REPORT"
          }
          width={1500}
          height={"auto"}
          onHiding={onHiding}
        >
          <TrainingReport
            trRecData={trRecData}
            // fileListDataSource={fileListDataSource}
            // setSetFileListDataSource={setSetFileListDataSource}
            // reportTabPanelRef={reportTabPanelRef}
            // reportDescriptionRef={reportDescriptionRef}
            // setReportDescr={setReportDescr}
            // reportDescr={reportDescr}
            trRecGridRef={trRecGridRef}
            reportPopupVisible={reportPopupVisible}
            setReportPopupVisible={setReportPopupVisible}
            userInfo={userInfo}
            currentEmployeeNo={currentEmployeeNo}
          />
        </Popup>
      )}
    </React.Fragment>
  );
}
